var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"data-list"},_vm._l((_vm.listItems),function(item){return _c('hh-data-item',{key:item[0],attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }